export default function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-brush/src/event.js
// module id = 644
// module chunks = 0